import { useLazyQuery } from '@apollo/client';

import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';

import { notificationService } from '@/services/notification/notification.client';

import GetVarBillingUsageHeaderQuery from '@/graphql/contracts//getVarBillingUsageHeader.query.gql';


import { GetVarBillingUsageHeader, GetVarBillingUsageHeaderVariables } from
  '@/graphql/contracts/_generated_/getVarBillingUsageHeader.query';

export default function useGetVarBillingUsageHeader() {
  const [_getVarBillingUsageHeader, { loading, error, data }] =
    useLazyQuery<GetVarBillingUsageHeader, GetVarBillingUsageHeaderVariables>(GetVarBillingUsageHeaderQuery, {
      client: apolloClientContracts,
      fetchPolicy: 'network-only',
      onError: (err) => notificationService.open({
        title: 'Error',
        text: err.message,
        type: 'danger'
      }),
    });

  const getVarBillingUsageHeader = (documentID: string) => {
    _getVarBillingUsageHeader({
      variables: {
        id: documentID

      },
    });
  };


  return {
    getVarBillingUsageHeader,
    varBillingUsageHeader: data?.varBillingUsageHeader,
    isLoadingUsageHeader: loading,
    errorUsageHeader: error,
  } as const;
}
